import PropTypes from "prop-types"
import React from "react"
import withRouter from "components/Common/withRouter"

//i18n
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logoLight from "../../assets/images/logo-light.png"
import logoIcon from "../../assets/images/logo-icon.png"
import useAuth from "hooks/useAuth"
import redirectUser from "helpers/redirectUser"

const Sidebar = () => {
  const { userData } = useAuth()

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box mt-1">
          <Link
            to={redirectUser(userData.user_type)}
            className="logo logo-light"
          >
            <span className="logo-sm">
              <img src={logoIcon} alt="logo-icon" height="30" />
            </span>
            <span className="logo-lg">
              <img src={logoLight} alt="logo-light" height="30" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          <SidebarContent />
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

export default withRouter(Sidebar)
